module.exports = __webpack_public_path__ + "static/media/Signoras Bakery hero 222.fa9b99a3.jpg";